// extracted by mini-css-extract-plugin
module.exports = {"message":"DeliveryHighlights_message__2z7cN","deliveryMessage":"DeliveryHighlights_deliveryMessage__QQIhN"};